'use strict';

angular.module('portal.services')
    .controller('PortalServiceInspections', ['$scope', 'IPInspections', '$rootScope', '$state', function ($scope, IPInspections, $rootScope, $state) {
        $scope.resetService();
        $scope.bulkActionItems = [];
        $scope.assigning = false;

        $scope.payInspectionFees = function (bulkActionItems) {
            $scope.assigning = true;

            IPInspections.bulkAction(bulkActionItems, null, 'fee').then(function () {
                $state.go('portal.menus.checkoutlist');
            })
        }

        $scope.columns = [
            {
                label: 'Service/Vehicle',
                field: 'name',
                hideAction: 'checklist.payment_handled',
                document: {
                    id: 'checklist.document.id',
                    code: 'checklist.document.code',
                    url: $rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument'
                },
                info: [
                   {
                       label: 'Unit Number',
                       field: 'unit_number'
                   },
                   {
                       label: 'Call Sign',
                       field: 'call_sign'
                   }
                ]
            },
            {
                label: 'Number',
                field: 'number'
            },
            {
                label: 'Date',
                field: 'inspection_date',
                type: 'datetime',
                dateTimeFlag: 'date_time_set'
            },
            {
                label: 'Total Fee',
                field: 'total_fee',
                type: 'money'
            },
            {
                label: 'Deficiencies',
                field: 'checklist.deficiencies_fail',
                type: 'deficiency_total'
            },
            {
                label: 'Status',
                field: 'status.name'
            }
        ];

        $scope.filters = [
            {
                name: 'Status',
                field: 'status_id',
                service: 'IPStatuses'
            }
        ];
    }])
;